import {
  CHECK_AUTH_TYPE,
  CHECK_AUTH_TYPE_SUCCESSFUL,
  CHECK_AUTH_TYPE_FAILED,
} from "./actionTypes"

export const checkAuthType = callback => {

  return {
    type: CHECK_AUTH_TYPE,
    payload: { callback },
  }
}

export const checkAuthTypeSuccessful = callback => {
  return {
    type: CHECK_AUTH_TYPE_SUCCESSFUL,
    payload: callback,
  }
}

export const checkAuthTypeFailed = callback => {
  return {
    type: CHECK_AUTH_TYPE_FAILED,
    payload: callback,
  }
}
